import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import { IconButton, InputAdornment } from '@mui/material';

import AppButton from '../../components/designe/app-button/AppButton';
import { Paths } from '../../shared/paths';
import { useStyles } from './SignIn.styles';
import theme from '../../styles/theme';
import { useSignInPage } from './useSignInPage';
import AppFormTextField from '../../components/designe/app-form-text-field';

const SignIn = (props) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const { classes } = useStyles(theme);
  const { formik } = useSignInPage();

  return (
    <div className={classes.signInWrapper}>
      <div className={classes.signInContentWrapper}>
        <form onSubmit={formik.handleSubmit} className={classes.signInForm}>
          <AppFormTextField
            label={t('common.email')}
            fullWidth
            name="email"
            formik={formik}
            className={classes.textField}
          />
          <AppFormTextField
            label={t('common.password')}
            fullWidth
            name="password"
            type={showPassword ? 'text' : 'password'}
            formik={formik}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="large">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <div className={classes.signInForgotPasswordButton}>
            <Link to={Paths.forgotPassword}> {t('signIn.forgotPassword')}</Link>
          </div>

          <AppButton type="submit" fullWidth>
            {t('signIn.signIn')}
          </AppButton>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
